<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12>
   			<v-card>
	   			<v-card-title>

            <v-text-field v-model="filter.code" label="Return ID" class="mr-3"></v-text-field>
            
            <v-autocomplete v-model="filter.status" :items="statuses" item-text="title" item-value="id" label="Status" class="mr-3"></v-autocomplete>
            
            <v-autocomplete v-model="filter.type" :items="types" item-text="title" item-value="id" label="Type" class="mr-3"></v-autocomplete>

            <search-btn @click="filterData" />

            <v-spacer></v-spacer>

            <v-btn v-if="hasCreateAccess" to="/purchase-return" round color="primary" dark small class="ml-4">Add New</v-btn>

			    </v-card-title>
	   			<v-data-table
				    :headers="headers"
				    :loading="processing"
				    :items="items"
				    item-key="id"
				    hide-actions
            disable-initial-sort
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
              <tr is="purchase-return-list-item" :item="props.item" @cancel="confirmCancelItem"></tr>
				    </template>
				    <template slot="no-data" v-if="!processing && !items.length">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>

          <v-pagination @loadPage="loadPage" />

			</v-card>
   		</v-flex>

      <action-dialog action="cancel" :status="cancelDialog" @close="closeCancelDialog" @success="cancelPurchaseReturn" />

   	</v-layout>
    
  </v-flex>
</template>

<script>

  import PurchaseReturnListItem from './PurchaseReturnListItem'

  export default {
    data () {
      return {
      	title: "Purchase Return List",
      	processing: false,
      	items: [],
        headers: [
          { text: 'Return ID', value: 'code'},
          { text: 'Purchase ID', value: 'purchase_code'},
          { text: 'Return Date', value: 'added_time'},
          { text: 'Total (Rs.)', value: 'grandtotal', align: 'right'},
          { text: 'Status', value: 'status', align: 'center', sortable: false },
          { text: 'Actions', value: 'id', sortable: false }
        ],
        cancellingItem: null,
        cancelDialog: false,
        filter: {
          type: "",
          code: "",
          status: ""
        },
        types: [
          {
            id: "",
            title: "All"
          }
        ],
        statuses: [
          {
            id: "",
            title: "All"
          }
        ],
      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Purchase Return',
	          disabled: true
	        },
	        {
	          text: 'List',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Purchase Return')
    },
    methods: {

      loadPage () {

        let api_path = this.config.apis.getPurchaseReturns.replace(":page", this.currentPage).replace(":perPage", this.paginationOptions.rowsPerPage)
          
        let filterArray = []

        for (const [key, val] of Object.entries(this.filter)) {
          if (val || val === 0) {
            filterArray.push(`${key}=${val}`)
          }
        }

        if (filterArray.length) {
          api_path += '?' + filterArray.join('&')
        }
        
        this.processing = true
        this.axios.get(api_path)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
            	this.items = response.data.data.items
              this.$store.commit('setItemsCount', response.data.data.total)
            }
            else{
            	this.items = []
              this.$store.commit('setItemsCount', 0)
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      confirmCancelItem (item) {
        this.cancellingItem = item
        this.cancelDialog = true
      },

      closeCancelDialog () {
        this.cancellingItem = null
        this.cancelDialog = false
      },

      cancelPurchaseReturn () {
        
        if (!this.cancellingItem) return

        this.processing = true
        this.axios.put(this.config.apis.cancelPurchaseReturn.replace(":id", this.cancellingItem.id))
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              this.cancellingItem.status = this.config.purchaseReturnStatus.cancelled

              this.notifySuccess('updateSuccess')
              this.closeCancelDialog()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.closeCancelDialog()
          })
      }

    },
    mounted () {
      
      for (const [key, val] of Object.entries(this.config.purchaseTypes)) {
        this.types.push({id: val, title: key})
      }

      for (const [key, val] of Object.entries(this.config.purchaseReturnStatus)) {
        this.statuses.push({id: val, title: key})
      }
      
    },

    computed: {

    },

    watch: {

    },
    
    components: {
      'purchase-return-list-item': PurchaseReturnListItem
    }

  }
</script>
